import{declineByCount as n}from"./declineByCount.js";function o(e){return n(["оценка","оценки","оценок"],e)}export{o as getVerbalReviews};
